import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-regular-svg-icons'


const UnfilledStar = ({size,colour,onClick}) => {
return (
    <FontAwesomeIcon onClick={onClick} size={size} color={colour} icon={faStar} />
);
}

export default UnfilledStar;